export default __webpack_public_path__ + "static/media/i-inst.a20cac40.svg";